
$(function () {
    $(".lead-dup").each(function (idx, element) {
        var id = $(element).data("id");
        var $list = $(element).find("ul");

        var _renderDuplicate = function(total, text){
            $list.append("<li><span class='total'>" + total +
                    "</span> with same <a>" + text + "</a></li>");
        };

        var _processData = function (d) {
            if (d.PersonalEmail > 0) {
                _renderDuplicate(d.PersonalEmail, "personal email");
            }

            if (d.CompanyEmail > 0) {
                _renderDuplicate(d.CompanyEmail, "company email");
            }

            if (d.CompanyName > 0) {
                _renderDuplicate(d.CompanyName, "company name");
            }

            $(element).show();
        };

        var _fetchDuplicates = function () {
            $.ajax({
                url: '/admin/leads/duplicatecountsasync/' + id,
                method: 'GET',
                success: function (d) {
                    if (!d || (!d.PersonalEmail && !d.CompanyEmail && !d.CompanyName))
                        return;

                    _processData(d);
                },
                error: function (x, s, e) {
                    console.log(e);
                }
            });
        };

        _fetchDuplicates();
    });
});